export const fonts = {
	mainColor: '#000',
	mainFont: 'Roboto',
	mainStyle: 'normal',
}
